var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.payment_methods.length)?_c('div',{staticClass:"background"},[_c('h5',[_vm._v(" Forma de pago ")]),_c('payment-methods'),_c('total')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }